module.exports = __webpack_public_path__ + "img/overview8.14294b6f.png";